module.exports = __webpack_public_path__ + "img/logo-dark.2b54f458.png";